export interface FrameRouteDef {
  frameId: string;
  path: `/frame-${string}`;
  kbEligible: boolean;
}

/**
 * FRAME_REGISTRY
 *
 * Single source of truth for all frame routes eligible for KB assignment.
 *
 * Admin panel uses this to populate selectable frame targets.
 * Future routing and documentation can also consume this registry.
 *
 * Any new frame added to the platform should be added here once.
 */
export const FRAME_REGISTRY: FrameRouteDef[] = [
  { frameId: '123', path: '/frame-123', kbEligible: true },
  { frameId: '126', path: '/frame-126', kbEligible: true },
  { frameId: '129', path: '/frame-129', kbEligible: true },
  { frameId: '130', path: '/frame-130', kbEligible: true },

  { frameId: '132', path: '/frame-132', kbEligible: true },
  { frameId: '133', path: '/frame-133', kbEligible: true },
  { frameId: '135', path: '/frame-135', kbEligible: true },

  { frameId: '137', path: '/frame-137', kbEligible: true },
  { frameId: '138', path: '/frame-138', kbEligible: true },

  { frameId: '140', path: '/frame-140', kbEligible: true },
  { frameId: '141', path: '/frame-141', kbEligible: true },
  { frameId: '142', path: '/frame-142', kbEligible: true },
  { frameId: '143', path: '/frame-143', kbEligible: true },
  { frameId: '144', path: '/frame-144', kbEligible: true },
  { frameId: '145', path: '/frame-145', kbEligible: true },
  { frameId: '146', path: '/frame-146', kbEligible: true },
  { frameId: '147', path: '/frame-147', kbEligible: true },

  { frameId: '155', path: '/frame-155', kbEligible: true },

  { frameId: '157', path: '/frame-157', kbEligible: true },
  { frameId: '158', path: '/frame-158', kbEligible: true },
  { frameId: '159', path: '/frame-159', kbEligible: true },
  { frameId: '160', path: '/frame-160', kbEligible: true },
  { frameId: '161', path: '/frame-161', kbEligible: true },

  { frameId: '163', path: '/frame-163', kbEligible: true },
  { frameId: '165', path: '/frame-165', kbEligible: true },

  { frameId: '172', path: '/frame-172', kbEligible: true },
  { frameId: '173', path: '/frame-173', kbEligible: true },
  { frameId: '174', path: '/frame-174', kbEligible: true },

  { frameId: '182', path: '/frame-182', kbEligible: true },

  { frameId: '186', path: '/frame-186', kbEligible: true },
  { frameId: '187', path: '/frame-187', kbEligible: true },
  { frameId: '188', path: '/frame-188', kbEligible: true },
  { frameId: '189', path: '/frame-189', kbEligible: true },
  { frameId: '190', path: '/frame-190', kbEligible: true },
  { frameId: '191', path: '/frame-191', kbEligible: true },
  

  { frameId: '196', path: '/frame-196', kbEligible: true },

  { frameId: '199', path: '/frame-199', kbEligible: true },

  { frameId: '202', path: '/frame-202', kbEligible: true },
  { frameId: '203', path: '/frame-203', kbEligible: true },

  { frameId: '212', path: '/frame-212', kbEligible: true },

  { frameId: '214', path: '/frame-214', kbEligible: true },
  { frameId: '215', path: '/frame-215', kbEligible: true },

  { frameId: '219', path: '/frame-219', kbEligible: true },

  { frameId: '221', path: '/frame-221', kbEligible: true },
  { frameId: '222', path: '/frame-222', kbEligible: true },
  { frameId: '223', path: '/frame-223', kbEligible: true },
  { frameId: '224', path: '/frame-224', kbEligible: true },

  { frameId: '234', path: '/frame-234', kbEligible: true },
  { frameId: '235', path: '/frame-235', kbEligible: true },
  { frameId: '236', path: '/frame-236', kbEligible: true },
  { frameId: '237', path: '/frame-237', kbEligible: true },
  { frameId: '238', path: '/frame-238', kbEligible: true },
  { frameId: '239', path: '/frame-239', kbEligible: true },
  { frameId: '240', path: '/frame-240', kbEligible: true },
  { frameId: '241', path: '/frame-241', kbEligible: true },
  { frameId: '242', path: '/frame-242', kbEligible: true },
  { frameId: '243', path: '/frame-243', kbEligible: true },
  { frameId: '244', path: '/frame-244', kbEligible: true },
  { frameId: '244-pets', path: '/frame-244-pets', kbEligible: true },
  { frameId: '245', path: '/frame-245', kbEligible: true },
  { frameId: '246', path: '/frame-246', kbEligible: true },
  { frameId: '247', path: '/frame-247', kbEligible: true },
  { frameId: '248', path: '/frame-248', kbEligible: true },

  { frameId: '249', path: '/frame-249', kbEligible: true },

  { frameId: '250', path: '/frame-250', kbEligible: true },
  { frameId: '251', path: '/frame-251', kbEligible: true },

  { frameId: '260', path: '/frame-260', kbEligible: true },
  { frameId: '261', path: '/frame-261', kbEligible: true },

  { frameId: '800', path: '/frame-800', kbEligible: true },
  { frameId: '801', path: '/frame-801', kbEligible: true },
  { frameId: '802', path: '/frame-802', kbEligible: true },
  { frameId: '803', path: '/frame-803', kbEligible: true },
];